<template lang="pug">
#base-card
    span {{ titulo }}
    span {{ valor }}
</template>

<script>
export default {
    name: 'CardDadosDashboardMonitoramento',

    props: {
        titulo: {
            type: String,
            required: true
        },
        valor: {
            type: Number,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
#base-card {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border: solid 2px;
    border-radius: 10px;
    padding: 2%;
    font-weight: bold;
    padding: 1% 2%;
}
</style>
